import { render, staticRenderFns } from "./funesPresMD.vue?vue&type=template&id=15aef043"
import script from "./funesPresMD.vue?vue&type=script&lang=js"
export * from "./funesPresMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports